import { createAsyncThunk } from "@reduxjs/toolkit";

import { toast } from "react-toastify";
import 'react-toastify/dist/ReactToastify.css';
import { GetAllDesignation, CreateNewDesignation, UpdateDesignation, DeleteDesignation, AssignDesignation, GetActiveEmployees } from "helpers/api_method";

export const getAllDesignationList = createAsyncThunk("designation/getAllDesignationList", async () => {
    try {
        const response = await GetAllDesignation();
        return response.data;
    } catch (error) {
        return error;
    }
});
export const addNewDesignation = createAsyncThunk("designation/addNewDesignation", async (event: any) => {
    try {
        const response = await CreateNewDesignation(event);
        toast.success("Designation created Successfully", { autoClose: 2000 });
        return response.data;
    } catch (error) {
        toast.error("Designation creation Failed", { autoClose: 2000 });
        return error;
    }
});
export const updateExistingDesignation = createAsyncThunk("designation/updateExistingDesignation", async (event: any) => {
    try {
        const response = await UpdateDesignation(event.id, event);
        toast.success("Designation updated Successfully", { autoClose: 2000 });
        return response.data;
    } catch (error) {
        toast.error("Designation updated Failed", { autoClose: 2000 });
        return error;
    }
});
export const updateUserDesignation = createAsyncThunk("designation/updateUserDesignation", async (event: any) => {
    try {
        const response = await AssignDesignation(event.designation_id, event);
        toast.success("Designation assigned Successfully", { autoClose: 2000 });
        return response.data;
    } catch (error) {
        toast.error("Designation assign Failed", { autoClose: 2000 });
        return error;
    }
});
export const deleteExistingDesignation = createAsyncThunk("designation/deleteExistingDesignation", async (event: any) => {
    try {
        const response = await DeleteDesignation(event.id);
        toast.success("Designation deleted Successfully", { autoClose: 2000 });
        return response.data;
    } catch (error) {
        toast.error("Designation deletion Failed", { autoClose: 2000 });
        return error;
    }
});

export const getAllDesignationUsers = createAsyncThunk("designation/getAllDesignationUsers", async () => {
    try {
        const response = await GetActiveEmployees();
        return response.data;
    } catch (error) {
        return error;
    }
});